import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SetupUserComponent } from './component/setup-user/setup-user.component';

const routes: Routes = [
  { path: 'setup-user', component: SetupUserComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class WelcomeRoutingModule {
}
